import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  QaiButtonComponent,
  QaiFlexContainerComponent,
  QaiScoreWeightCardComponent,
} from '@qai/ui';
import { EditWeightingModalComponent } from '../modals/edit-weighting/edit-weighting-modal.component';
import { IScoreWeight } from 'src/app/interfaces/self-serve/isimulation-score';
import { AuthorService } from 'src/app/services/self-serve/author.service';
import { ActivatedRoute } from '@angular/router';
import { AuthorReactiveFormService } from '../../services/author-reactive-form.service';

@Component({
  selector: 'scoring-weights',
  standalone: true,
  templateUrl: './scoring-weights.component.html',
  styleUrls: ['./scoring-weights.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    QaiButtonComponent,
    QaiFlexContainerComponent,
    QaiScoreWeightCardComponent,
    EditWeightingModalComponent,
  ],
})
export class ScoringWeightsComponent {
  @Input() weights: IScoreWeight[] = [];

  openEditModal = false;
  modalWeights: IScoreWeight[] = [];
  callUuid: string = '';
  readOnly: boolean = false;

  constructor(
    private authorService: AuthorService,
    private route: ActivatedRoute,
    private authorReactiveFormService: AuthorReactiveFormService
  ) {}

  ngOnInit(): void {
    this.callUuid = this.route.snapshot.paramMap.get('uuid') || '';

    this.readOnly = this.authorReactiveFormService.isReadOnly(this.callUuid);
  }

  editWeighting(): void {
    this.modalWeights = this.weights.map((weight) => ({ ...weight }));
    this.openEditModal = true;
  }

  handleModalConfirm(updatedWeights: IScoreWeight[]) {
    this.weights = [...updatedWeights];

    this.authorReactiveFormService.patchForm(this.callUuid, 'scoring', {
      sectionWeights: updatedWeights,
    });

    this.openEditModal = false;
  }

  handleModalClose() {
    this.openEditModal = false;
  }
}
